import React from 'react'
import loaderFile   from '../../Assets/Images/loader.gif';

function Loader({ width = '125px', loaderclass }) {
  return (
    <div>
      <center>
        <img className={loaderclass !== undefined && loaderclass !== null ? loaderclass : "loader"} src={loaderFile} style={{ width: width }} alt="Loading..." />
      </center>
    </div>
  );
}


export default Loader